import HeroSection from '@/components/sections/environmental/HeroSection';
import CarbonCalculator from '@/components/sections/environmental/CarbonCalculator';
import SEO from '@/components/SEO';
import FAQ from '@/components/ui/FAQ';
import ReductionMeasuresSection from '@/components/sections/environmental/ReductionMeasuresSection';
import TreePlantingSection from '@/components/sections/environmental/TreePlantingSection';
import BookingModule from '@/components/sections/BookingModule';
import CTASection from '@/components/sections/environmental/CTASection';

const EngagementEnvironnemental = () => {
  const faqItems = [
    {
      question: "Comment calculez-vous l'empreinte carbone d'un projet ?",
      answer: "Nous utilisons une méthodologie complète qui prend en compte : la consommation énergétique des serveurs, l'impact du développement, l'utilisation des ressources, et la maintenance. Notre calcul est basé sur des standards internationaux."
    },
    {
      question: "Comment fonctionne le programme de plantation d'arbres ?",
      answer: "Pour chaque projet, nous calculons le nombre d'arbres nécessaires pour compenser son empreinte carbone. Les clients peuvent choisir parmi plusieurs zones de plantation, chacune ayant des bénéfices environnementaux spécifiques. Nous travaillons avec des associations pour assurer la plantation et le suivi."
    },
    {
      question: "Quels sont les bénéfices environnementaux au-delà de la compensation carbone ?",
      answer: "La plantation d'arbres contribue à la biodiversité, protège les sols, régule le cycle de l'eau, et soutient les écosystèmes locaux. De plus, nos projets créent des emplois locaux et renforcent les communautés dans les zones de plantation."
    },
    {
      question: "Quelles sont vos mesures pour réduire l'empreinte carbone en interne ?",
      answer: "Nous optimisons notre code, pratiquons le télétravail, et réduisons notre consommation de papier. Nous formons également nos équipes aux bonnes pratiques de développement durable."
    },
    {
      question: "Comment puis-je participer à ce programme ?",
      answer: "Chaque projet que nous développons inclut automatiquement le programme de compensation carbone. Vous pouvez choisir votre zone de plantation préférée et suivre l'impact de votre contribution."
    }
  ];

  return (
    <>
      <SEO 
        title="Notre Engagement Environnemental"
        description="Découvrez comment Orcsys compense l'empreinte carbone de chaque projet en plantant des arbres. Notre engagement pour un impact environnemental positif et une technologie durable."
        keywords="empreinte carbone, développement durable, compensation carbone, plantation d'arbres, technologie verte, développement web écologique, impact environnemental positif"
        type="page"
        url="https://innov.orcsys.fr/engagement-environnemental"
        image="https://innov.orcsys.fr/images/environmental-commitment-preview.png"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <CarbonCalculator />
        <TreePlantingSection />
        <ReductionMeasuresSection />
        <CTASection />
        <BookingModule />
        <FAQ 
          title="Questions Fréquentes sur Notre Engagement Environnemental"
          subtitle="Découvrez comment nous créons un impact positif sur l'environnement"
          items={faqItems}
          className="bg-slate-50"
        />
        
      </div>
    </>
  );
};

export default EngagementEnvironnemental; 